import React, { useEffect, useMemo } from "react"
import Grid from '@mui/material/Grid';
import OutlinedInput from '@mui/material/OutlinedInput';
import { Select, MenuItem, Paper, Chip, Button } from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import DefaultSelectClient from "../../components/default-select-client";
import { useConsultaDiarioOficialController } from "./context/consulta-diario-oficial-controller";
import { ACTION_TYPES, useConsultaDiarioOficialDispatch, useConsultaDiarioOficialState } from "./context/consulta-diario-oficial-context";
import { DataGrid, GridColDef, GridPaginationModel } from '@mui/x-data-grid';
import moment from 'moment';
import { IconButton, ListItemIcon, ListItemText } from '@mui/material';
import Menu from "@mui/material/Menu";
import DoDisturbIcon from '@mui/icons-material/DoDisturb';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import SettingsIcon from '@mui/icons-material/Settings';
import { DefaultDialogProps } from "../../components/default-dialog";
import OfficialDiaryAppService from "../../../application/platform/official-daily/official-daily-app-service";
import { IOfficialDiaryPagedResponse } from "../../../model/official-daily/response/official-diary-paged-response";
import DisplaySettingsIcon from '@mui/icons-material/DisplaySettings';
import { useBaseLayoutController } from "../../base-layout/context/base-layout-controller";
import { useNavigate, useParams } from "react-router-dom";
import dayjs, { Dayjs } from "dayjs";
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import PublicationShipmentAppService from "../../../application/platform/publication-shipment/publication-shipment-app-service";
import { IUpdatePublicationShipmentRequest } from "../../../model/publication-shipment/request/update-publication-shipment-request";
import ApplicationAppService from "../../../application/platform/application-app-service";
import { getDataGridLocaleText, dataGridDefaultSx, dataGridDefaultProps } from "../../../config/datagrid-config";

export const ConsultaDiarioOficial = () => {
    const { handleOnChange, clearFieldss, loadData, onChangePagination } = useConsultaDiarioOficialController();
    const { officialDiaryPagedRequest, isLoadingData, officialDiaryPagedResponse } = useConsultaDiarioOficialState();
    const { showBackDrop, showDialog } = useBaseLayoutController();
    const navigate = useNavigate();
    const consultaDiarioOficialDispatch = useConsultaDiarioOficialDispatch();
    const { publicationShipmentId } = useParams();

    useEffect(() => {

        (async () => {
            await clearFieldss();
            if (publicationShipmentId !== undefined) {
                await PublicationShipmentAppService.update({ id: Number(publicationShipmentId), statusId: 2 } as IUpdatePublicationShipmentRequest);
            }
        })();
    }, []);

    function MenuPopupState({ isClosed, isVisibility, id }: { isClosed: boolean; isVisibility: boolean; id: number; }) {
        const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
        const open = Boolean(anchorEl);
        const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
            setAnchorEl(event.currentTarget);
        };
        const handleClose = () => {
            setAnchorEl(null);
        };

        const changeVisibility = () => {
            handleClose();
            (async () => {
                showDialog({
                    open: true,
                    message: `Deseja realmente tornar essa Edição do Diário ${isVisibility ? 'invisível' : 'vísível'}?`,
                    onYesClick: () => {
                        (async () => {
                            showBackDrop(true);
                            await OfficialDiaryAppService.changeVisibility(id);
                            showBackDrop(false);
                            loadData(officialDiaryPagedRequest);
                        })();
                    }

                } as DefaultDialogProps);

            })();

        }
        const closeOfficialDaily = () => {
            handleClose();
            (async () => {
                showDialog({
                    open: true,
                    message: `Deseja realmente fechar essa Edição do Diário?`,
                    onYesClick: () => {
                        (async () => {
                            showBackDrop(true);
                            await OfficialDiaryAppService.close(id);
                            showBackDrop(false);
                            loadData(officialDiaryPagedRequest);
                        })();
                    },
                } as DefaultDialogProps);

            })();
        }
        const gotToDetails = () => {
            handleClose();
            navigate(`/detalhes-diario-oficial/${id}`);

        }

        let itemMenuClosed = undefined;

        if (!isClosed) {
            itemMenuClosed = <MenuItem onClick={closeOfficialDaily}>
                <ListItemIcon>
                    <DoDisturbIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Fechar Edição</ListItemText>
            </MenuItem>
        }


        return (


            <div>
                <IconButton
                    color="primary"
                    // variant="contained"
                    id="basic-button"
                    aria-controls={open ? 'basic-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                    onClick={handleClick}>
                    <SettingsIcon />
                </IconButton>

                <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    MenuListProps={{
                        'aria-labelledby': 'basic-button',
                    }}
                >
                    <MenuItem onClick={gotToDetails}>
                        <ListItemIcon>
                            <DisplaySettingsIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Detalhes</ListItemText>
                    </MenuItem>
                    <MenuItem onClick={changeVisibility}>
                        <ListItemIcon>
                            {isVisibility ? (
                                <VisibilityOffIcon fontSize="small" />
                            ) : (
                                <VisibilityIcon fontSize="small" />
                            )}
                        </ListItemIcon>
                        <ListItemText>{isVisibility ? 'Tornar Invisível' : 'Tornar Visível'}</ListItemText>
                    </MenuItem>
                    {itemMenuClosed}

                </Menu>
            </div>
        );
    }

    const paginationModel = useMemo(() => ({
        page: officialDiaryPagedRequest?.page ?? 0,
        pageSize: officialDiaryPagedResponse?.pageSize ?? 50
    }), [officialDiaryPagedRequest?.page, officialDiaryPagedResponse?.pageSize]);

    const columns: GridColDef<IOfficialDiaryPagedResponse>[] = [
        { field: 'id', headerName: 'Id', width: 90 },
        {
            field: 'editionNumber',
            headerName: 'Nº Edição/Ano',
            flex: 1,
            renderCell: (params: { row: { editionNumber: string; yearPublication: string; }; }) => {
                return params.row.editionNumber + '/' + params.row.yearPublication
            }
        },
        {
            field: 'publicationDate',
            headerName: 'Publicada em',
            flex: 1,
            valueFormatter: params => {
                return moment(params).format("DD/MM/YYYY")
            }
        },
        {
            field: 'description',
            headerName: 'Descrição',
            flex: 3
        },
        {
            field: 'clientName',
            headerName: 'Entidade',
            flex: 3
        },
        {
            field: 'closedOn',
            headerName: 'Fechada em',
            flex: 1,
            valueFormatter: (params) => params !== undefined && params !== null ? moment(params).format("DD/MM/YYYY") : null,
        },
        {
            field: 'isClosed',
            headerName: 'Fechada',
            width: 90, align: 'center',
            headerAlign: 'center',
            renderCell: (params: { row: { isClosed: any; }; }) => {
                let chip = <Chip label={"NÃO"} color="error" />
                if (params.row.isClosed) {
                    chip = <Chip label={"SIM"} color="success" />
                }
                return chip;
            }
        },
        {
            field: 'isVisibility',
            headerName: 'Visível',
            width: 90,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params: { row: { isVisibility: any; }; }) => {
                let chip = <Chip label={"NÃO"} color="error" />
                if (params.row.isVisibility) {
                    chip = <Chip label={"SIM"} color="success" />
                }
                return chip;
            }
        },

        {
            field: 'isExtra',
            headerName: 'Extra',
            width: 90,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params: { row: { isExtra: any; }; }) => {
                let chip = <Chip label={"NÃO"} color="error" />
                if (params.row.isExtra) {
                    chip = <Chip label={"SIM"} color="success" />
                }
                return chip;
            }
        },
        {
            field: "action",
            headerName: "",
            sortable: false,
            width: 160,
            align: "center",
            headerAlign: "center",
            renderCell: (params: { row: { isClosed: boolean; isVisibility: boolean; id: number; }; }) => {
                return (
                    <MenuPopupState isClosed={params.row.isClosed} isVisibility={params.row.isVisibility} id={params.row.id} ></MenuPopupState>

                );
            }
        }
    ];
    return (

        <React.Fragment>
            <Grid item xs={12} md={12} lg={12}>
                <Paper
                    sx={{
                        p: 2,
                        display: 'flex',
                        flexDirection: 'column'
                    }}
                >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Grid
                            container spacing={1.5}
                        >       <Grid
                            item
                            lg={2}
                            sm={2}
                            xl={2}
                        >
                                <InputLabel>Nº Edição</InputLabel>
                                <OutlinedInput
                                    size="small"
                                    name="input-number"
                                    fullWidth
                                    type={"number"}
                                    inputProps={{ min: 0 }}
                                    value={officialDiaryPagedRequest?.number}
                                    onChange={handleOnChange}
                                />
                            </Grid>
                            <Grid
                                item
                                lg={2}
                                sm={2}
                                xl={2}
                            >
                                <InputLabel>Nº Ano</InputLabel>
                                <OutlinedInput
                                    size="small"
                                    name="input-year"
                                    fullWidth
                                    type={"number"}
                                    inputProps={{ min: 0 }}
                                    value={officialDiaryPagedRequest?.year}
                                    onChange={handleOnChange}
                                />
                            </Grid>
                            <Grid item lg={4}
                                sm={4}
                                xl={4}>
                                <InputLabel>Status</InputLabel>
                                <Select fullWidth size="small" name="select-closed" value={officialDiaryPagedRequest?.isClosed} onChange={handleOnChange}>
                                    <MenuItem value={undefined}>
                                        <em>Selecionar</em>
                                    </MenuItem>
                                    <MenuItem value={"true"} key={1}>FECHADA</MenuItem>
                                    <MenuItem value={"false"} key={2}>ABERTA</MenuItem>
                                </Select>
                            </Grid>
                            <Grid item lg={2}
                                sm={2}
                                xl={2}>
                                <InputLabel>Data Edição Inicial</InputLabel>
                                <DesktopDatePicker
                                    format='DD/MM/YYYY'
                                    name="input-start-date"
                                    slotProps={{ textField: { fullWidth: true, size: "small" } }}
                                    defaultValue={officialDiaryPagedRequest?.startDate !== undefined ? dayjs(officialDiaryPagedRequest?.startDate) : undefined}
                                    value={officialDiaryPagedRequest?.startDate !== undefined ? dayjs(officialDiaryPagedRequest?.startDate) : undefined}
                                    onChange={(value: Dayjs | null) => {
                                        let startDate = value?.format("YYYY-MM-DD");
                                        if (startDate !== null) {
                                            console.log('yrdyr');
                                            consultaDiarioOficialDispatch({
                                                type: ACTION_TYPES.setOfficialDiaryPagedRequest,
                                                payload: { ...officialDiaryPagedRequest, startDate },
                                            });
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid item lg={2}
                                sm={2}
                                xl={2}>
                                <InputLabel>Data Edição FInal</InputLabel>
                                <DesktopDatePicker
                                    format='DD/MM/YYYY'
                                    name="input-end-date"
                                    slotProps={{ textField: { fullWidth: true, size: "small" } }}
                                    defaultValue={officialDiaryPagedRequest?.endDate !== undefined ? dayjs(officialDiaryPagedRequest?.endDate) : undefined}

                                    value={officialDiaryPagedRequest?.endDate !== undefined ? dayjs(officialDiaryPagedRequest?.endDate) : undefined}
                                    onChange={(value: Dayjs | null) => {
                                        let endDate = value?.format("YYYY-MM-DD");
                                        if (endDate !== null) {
                                            consultaDiarioOficialDispatch({
                                                type: ACTION_TYPES.setOfficialDiaryPagedRequest,
                                                payload: { ...officialDiaryPagedRequest, endDate },
                                            });
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid item lg={8}
                                sm={8}
                                xl={8}>
                                <DefaultSelectClient required={false} clientId={officialDiaryPagedRequest?.clientId} handleOnChange={handleOnChange}></DefaultSelectClient>

                            </Grid>
                            <Grid item lg={2}
                                sm={2}
                                xl={2} direction="row" justifyContent="flex-end"
                                sx={{
                                    mt: 1,
                                    display: 'flex',
                                    flexDirection: "column",
                                    justifyContent: "flex-end",
                                    alignItems: "flex-end"
                                }}
                            >
                                <Button variant="contained" fullWidth size="small" onClick={async () => {
                                    await loadData(officialDiaryPagedRequest);
                                }} startIcon={<SearchIcon />}>Consultar</Button>
                            </Grid>
                            <Grid item lg={2}
                                sm={2}
                                xl={2} direction="row" justifyContent="flex-end"
                                sx={{
                                    mt: 1,
                                    display: 'flex',
                                    flexDirection: "column",
                                    justifyContent: "flex-end",
                                    alignItems: "flex-end"
                                }}
                            >
                                <Button variant="outlined" fullWidth size="small" onClick={async () => {
                                    await clearFieldss();
                                }} startIcon={<ClearIcon />}>Limpar</Button>
                            </Grid>
                        </Grid>
                    </LocalizationProvider>
                </Paper>
            </Grid>

            <Grid item xs={12} md={12} lg={12} sx={{}}>
                <Paper

                    sx={{
                        p: 2,
                        minHeight: "500px",
                        display: 'flex',
                        flexDirection: 'column'
                    }}
                >
                    <DataGrid
                        rows={officialDiaryPagedResponse.items}
                        columns={columns}
                        {...dataGridDefaultProps}
                        onPaginationModelChange={(e) => {
                            onChangePagination(e.page, e.pageSize);
                        }}
                        sx={dataGridDefaultSx}
                        localeText={getDataGridLocaleText(
                            officialDiaryPagedResponse.totalRecords,
                            officialDiaryPagedResponse.pageSize
                        )}
                        autoHeight={false}
                        paginationModel={paginationModel}
                        rowCount={officialDiaryPagedResponse.totalRecords}
                        loading={isLoadingData}
                    />
                    <SpeedDial
                        ariaLabel="SpeedDial basic example"
                        sx={{ position: 'absolute', bottom: 16, right: 16 }}
                        onClick={() => {
                            navigate(`/diagramar-diario-oficial`);
                        }}
                        icon={<SpeedDialIcon />}
                    >

                    </SpeedDial>
                </Paper>

            </Grid>
        </React.Fragment>
    )
}